import Swiper from "swiper";
import { Navigation, Pagination, Autoplay, EffectFade } from "swiper/modules";

import "swiper/css";
import "swiper/css/effect-fade";
import "./swiper-fallback.css";

// Respect reduced motion preference
const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

/* Hoogste aantal slides dat tegelijk zichtbaar is, over alle breekpunten heen. */
function maxSlidesPerView(opties) {
    const waarden = [opties.slidesPerView ?? 1];
    for (const bp of Object.values(opties.breakpoints ?? {})) {
        if (bp.slidesPerView) waarden.push(bp.slidesPerView);
    }
    return Math.max(...waarden.filter((v) => typeof v === "number"));
}

/* Start een carrousel, maar alleen als er genoeg slides zijn om er een te vullen.
   Met minder slides houdt Swiper ze op hun breukbreedte en oogt de rij te smal;
   dan leggen we ze gewoon naast elkaar (zie swiper-fallback.css). */
function maakSlider(container, opties) {
    const swiperEL = container.querySelector(".swiper");
    if (!swiperEL) return null;

    const aantal = swiperEL.querySelectorAll(".swiper-slide").length;
    const max = maxSlidesPerView(opties);

    // Bij één slide tegelijk (bijvoorbeeld een hero die van beeld wisselt) is een
    // carrousel met weinig beelden nog altijd de bedoeling; daar niets aan veranderen.
    if (max > 1 && aantal <= max) {
        container.classList.add("slider--geen-carrousel");
        container.querySelectorAll(".swiper-button-next, .swiper-button-prev, .swiper-pagination")
            .forEach((el) => el.remove());
        return null;
    }

    return new Swiper(swiperEL, opties);
}

const slidersImages = document.querySelectorAll(".images-slider");
const slidersTextMedia = document.querySelectorAll(".text-media-slider");
const slidersBrands = document.querySelectorAll(".brands-slider");
const slidersInstagram = document.querySelectorAll(".instagram-slider");
const slidersInstagramPetrus = document.querySelectorAll(".instagram-slider-petrus");
const slidersInstagramBavik = document.querySelectorAll(".instagram-slider-bavik");
const slidersInstagramLaneuf = document.querySelectorAll(".instagram-slider-laneuf");
const slidersLocations = document.querySelectorAll(".locations-slider");
const slidersCircusHero = document.querySelectorAll(".circus-hero-slider");
const slidersDbbBeers = document.querySelectorAll(".dbb-beers-slider");
const slidersDbbSlideshow = document.querySelectorAll(".dbb-slideshow");

document.addEventListener("DOMContentLoaded", () => {
    if (slidersDbbSlideshow) {
        slidersDbbSlideshow.forEach((el) => {
            const swiperEL = el.querySelector(".swiper");
            const nextEl = el.querySelector(".swiper-button-next");
            const prevEl = el.querySelector(".swiper-button-prev");

            const navigation = nextEl && prevEl ? { nextEl, prevEl } : undefined;

            maakSlider(el, {
                modules: [Navigation],
                speed: prefersReducedMotion ? 0 : 450,
                spaceBetween: 12,
                slidesPerView: 1.15,
                watchOverflow: true,
                navigation,
                breakpoints: {
                    640: { slidesPerView: 2.2, spaceBetween: 12 },
                    1024: { slidesPerView: 3, spaceBetween: 12 },
                    1280: { slidesPerView: 4, spaceBetween: 12 },
                },
            });
        });
    }

    if (slidersDbbBeers) {
        slidersDbbBeers.forEach((el) => {
            const swiperEL = el.querySelector(".swiper");
            const nextEl = el.querySelector(".swiper-button-next");
            const prevEl = el.querySelector(".swiper-button-prev");

            const navigation = nextEl && prevEl ? { nextEl, prevEl } : undefined;

            maakSlider(el, {
                modules: [Navigation, Autoplay],
                speed: prefersReducedMotion ? 0 : 500,
                spaceBetween: 24,
                slidesPerView: 1,
                loop: true,
                autoplay: prefersReducedMotion ? false : {
                    delay: 3500,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                },
                navigation,
                breakpoints: {
                    480: { slidesPerView: 2, spaceBetween: 24 },
                    768: { slidesPerView: 3, spaceBetween: 32 },
                    1024: { slidesPerView: 4, spaceBetween: 32 },
                },
            });
        });
    }

    if (slidersImages) {
        slidersImages.forEach((el) => {
            const swiperEL = el.querySelector(".swiper");
            const nextEl = el.querySelector(".swiper-button-next");
            const prevEl = el.querySelector(".swiper-button-prev");
            const paginationEl = el.querySelector(".swiper-pagination");

            const navigation = nextEl && prevEl ? { nextEl, prevEl, addIcons: false } : undefined;
            const pagination = paginationEl
                ? { el: paginationEl, clickable: true }
                : undefined;
            const swiper = maakSlider(el, {
                modules: [Navigation, Pagination],
                speed: 400,
                spaceBetween: 12,
                slidesPerView: 1,
                watchOverflow: true,
                navigation,
                pagination,
                breakpoints: {
                    480: {
                        slidesPerView: 1.5,
                        spaceBetween: 24,
                    },
                    720: {
                        slidesPerView: 3,
                        spaceBetween: 24,
                    },
                    1440: {
                        slidesPerView: 4,
                        spaceBetween: 24,
                    },
                },
            });
        });
    }

    if (slidersTextMedia) {
        slidersTextMedia.forEach((el) => {
            const swiperEL = el.querySelector(".swiper");
            const nextEl = el.querySelector(".swiper-button-next");
            const prevEl = el.querySelector(".swiper-button-prev");
            const paginationEl = el.querySelector(".swiper-pagination");

            const navigation = nextEl && prevEl ? { nextEl, prevEl, addIcons: false } : undefined;
            const pagination = paginationEl
                ? { el: paginationEl, clickable: true }
                : undefined;
            const swiper = maakSlider(el, {
                modules: [Navigation, Pagination],
                speed: 400,
                spaceBetween: 12,
                slidesPerView: 1,
                watchOverflow: true,
                navigation,
                pagination,
                breakpoints: {
                    480: {
                        slidesPerView: 1.5,
                        spaceBetween: 24,
                    },
                    720: {
                        slidesPerView: 2,
                        spaceBetween: 24,
                    },
                    1440: {
                        slidesPerView: 5,
                        spaceBetween: 24,
                    },
                },
            });
        });
    }

    if (slidersBrands) {
        slidersBrands.forEach((el) => {
            const swiperEL = el.querySelector(".swiper");
            const nextEl = el.querySelector(".swiper-button-next");
            const prevEl = el.querySelector(".swiper-button-prev");

            const navigation = nextEl && prevEl ? { nextEl, prevEl } : undefined;

            maakSlider(el, {
                modules: [Navigation, Autoplay],
                speed: prefersReducedMotion ? 0 : 400,
                spaceBetween: 32,
                slidesPerView: 2,
                loop: true,
                autoplay: prefersReducedMotion ? false : {
                    delay: 2500,
                    disableOnInteraction: false,
                },
                navigation,
                breakpoints: {
                    480: {
                        slidesPerView: 3,
                        spaceBetween: 40,
                    },
                    720: {
                        slidesPerView: 4,
                        spaceBetween: 48,
                    },
                    1024: {
                        slidesPerView: 5,
                        spaceBetween: 56,
                    },
                    1440: {
                        slidesPerView: 6,
                        spaceBetween: 64,
                    },
                },
            });
        });
    }

    if (slidersInstagram) {
        slidersInstagram.forEach((el) => {
            const swiperEL = el.querySelector(".swiper");
            const nextEl = el.querySelector(".swiper-button-next");
            const prevEl = el.querySelector(".swiper-button-prev");

            const navigation = nextEl && prevEl ? { nextEl, prevEl } : undefined;

            maakSlider(el, {
                modules: [Navigation],
                speed: 400,
                spaceBetween: 16,
                slidesPerView: 1.2,
                navigation,
                breakpoints: {
                    480: {
                        slidesPerView: 1.5,
                        spaceBetween: 20,
                    },
                    720: {
                        slidesPerView: 2.5,
                        spaceBetween: 24,
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 24,
                    },
                    1440: {
                        slidesPerView: 3.5,
                        spaceBetween: 24,
                    },
                },
            });
        });
    }

    if (slidersLocations) {
        slidersLocations.forEach((el) => {
            const swiperEL = el.querySelector(".swiper");
            const nextEl = el.querySelector(".swiper-button-next-locations");
            const prevEl = el.querySelector(".swiper-button-prev-locations");

            const navigation = nextEl && prevEl ? { nextEl, prevEl } : undefined;

            maakSlider(el, {
                modules: [Navigation],
                speed: 400,
                spaceBetween: 16,
                slidesPerView: 1,
                navigation,
                breakpoints: {
                    480: {
                        slidesPerView: 1.5,
                        spaceBetween: 20,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 24,
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 32,
                    },
                    1440: {
                        slidesPerView: 3,
                        spaceBetween: 64,
                    },
                },
            });
        });
    }

    if (slidersInstagramPetrus) {
        slidersInstagramPetrus.forEach((el) => {
            const swiperEL = el.querySelector(".swiper");
            const nextEl = el.querySelector(".swiper-button-next");
            const prevEl = el.querySelector(".swiper-button-prev");

            const navigation = nextEl && prevEl ? { nextEl, prevEl } : undefined;

            maakSlider(el, {
                modules: [Navigation],
                speed: 400,
                spaceBetween: 20,
                slidesPerView: 1,
                navigation,
                breakpoints: {
                    480: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                    },
                    1440: {
                        slidesPerView: 5,
                        spaceBetween: 20,
                    },
                },
            });
        });
    }

    if (slidersInstagramBavik) {
        slidersInstagramBavik.forEach((el) => {
            const swiperEL = el.querySelector(".swiper");
            const nextEl = el.querySelector(".swiper-button-next");
            const prevEl = el.querySelector(".swiper-button-prev");

            const navigation = nextEl && prevEl ? { nextEl, prevEl } : undefined;

            maakSlider(el, {
                modules: [Navigation],
                speed: 400,
                spaceBetween: 0,
                slidesPerView: 1,
                navigation,
                breakpoints: {
                    480: {
                        slidesPerView: 1,
                        spaceBetween: 0,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 0,
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 0,
                    },
                    1440: {
                        slidesPerView: 4,
                        spaceBetween: 0,
                    },
                },
            });
        });
    }

    if (slidersCircusHero) {
        slidersCircusHero.forEach((el) => {
            const swiperEL = el.querySelector(".swiper");
            const nextEl = el.querySelector(".swiper-button-next");
            const prevEl = el.querySelector(".swiper-button-prev");

            const navigation = nextEl && prevEl ? { nextEl, prevEl, addIcons: false } : undefined;

            maakSlider(el, {
                modules: [Navigation, Autoplay, EffectFade],
                effect: "fade",
                fadeEffect: { crossFade: true },
                // Snelle fade (200ms) zodat snel doorklikken meteen reageert
                // — voorheen 700ms voelde als "wachten op laden".
                speed: prefersReducedMotion ? 0 : 200,
                slidesPerView: 1,
                loop: true,
                autoplay: prefersReducedMotion ? false : {
                    delay: 5000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                },
                navigation,
                // Klik-events niet onderdrukken tijdens transitie.
                preventClicks: false,
                preventClicksPropagation: false,
            });
        });
    }

    if (slidersInstagramLaneuf) {
        slidersInstagramLaneuf.forEach((el) => {
            const swiperEL = el.querySelector(".swiper");
            const nextEl = el.querySelector(".swiper-button-next");
            const prevEl = el.querySelector(".swiper-button-prev");

            const navigation = nextEl && prevEl ? { nextEl, prevEl } : undefined;

            maakSlider(el, {
                modules: [Navigation],
                speed: 400,
                spaceBetween: 20,
                slidesPerView: 1,
                navigation,
                breakpoints: {
                    480: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 40,
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 60,
                    },
                },
            });
        });
    }
});
